module.exports = __webpack_public_path__ + "static/media/frowning-face-with-open-mouth-svgrepo-com.45f44dd3.svg";